module.exports = __webpack_public_path__ + "img/big-paper.64764bd4.png";